module.exports = __webpack_public_path__ + "img/bookado-logo.358442de.png";